if (typeof Aktualizace_Pracovniku === 'undefined') {

    var Aktualizace_Pracovniku = {

        init: function () {

            var button = $('#button-aktualizuj-pracovniky-z-titulu');
            if (!button.length) {
                return;
            }

            button
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var _ch = $('#_ch');
                    if (!_ch.length) {
                        return;
                    }

                    var url = window.location.protocol + '//' + window.location.host;
                    url += '/plugin/PluginZadost/ajaxAktualizacePracovniku';

                    $.ajax({
                        type: 'post',
                        url: url,
                        dataType: "json",
                        global: false,
                        data: {'_ch': _ch.val()},
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Aktualizuji pracovníky ve smlouvě ...', 'aktualizacePracovniku');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('aktualizacePracovniku');
                        },
                        success: function (r) {
                            if (r.hasOwnProperty('messages')) {
                                Lemo_Alert.addMany(r.messages);
                            }

                            if (r.hasOwnProperty('status') && true === r.status) {
                                DynaCore_Item.miniformReload(111, 93);
                            }
                        },
                        error: function () {
                            Lemo_Alert.addDanger('Aktualizace pracovníků selhala ...', 'aktualizacePracovnikuChyba');
                        }
                    });
                });
        }
    };
}

$(document)
    .ready(function () {
        Aktualizace_Pracovniku.init();
    });